import { useRef } from "react";
import CopyToClipboard from "react-copy-to-clipboard";
import toast from "react-hot-toast";
import { sendShareEventViaPixel } from "@qoohoo/common/utils/analytics/pixel";
import { button } from "@qoohoo/common/constants/analytics";
import getCurrentPageViewByUrl from "../hooks/getCurrentPageViewByUrl";
import * as Track from "@qoohoo/common/utils/analytics/track";
import { addTagsInRecording } from "@qoohoo/common/utils/analytics/clarity";

function CopyLink({ url, message, modalName = "modal", copyText }) {
  const defaultCopyText = message + "\n" + url;
  const copyTextToClipboard = copyText || defaultCopyText;
  const current_screen = getCurrentPageViewByUrl(url);

  const inputRef = useRef(null);

  return (
    <div className="flex items-center h-12 w-full overflow-hidden rounded-lg bg-[#1E2225] max-w-[312px] dark:bg-[#ececec]">
      <input
        ref={inputRef}
        className="px-4 h-full flex-1 overflow-hidden text-[#E8E8E8] text-[13px] leading-[20px] font-nunito bg-transparent outline-none dark:text-black"
        defaultValue={url.replace("https://", "") || ""}
        onClick={() => {
          if (inputRef.current) {
            inputRef.current.select();
          }

          sendShareEventViaPixel({ url, message });

          addTagsInRecording({
            copy_link: true,
            shareUrl: url,
            modal_name: modalName,
            current_screen,
          });

          Track.buttonClick(button.copy_link, {
            link: url,
            current_screen,
            modal_name: modalName,
          });
        }}
        readOnly
      />
      <svg
        width="1"
        height="20"
        viewBox="0 0 1 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="1" height="20" rx="0.5" fill="#49535A" />
      </svg>
      <CopyToClipboard
        text={copyTextToClipboard}
        onCopy={() => {
          sendShareEventViaPixel({ url, message });
          Track.buttonClick(button.copy_link, {
            link: url,
            current_screen,
            modal_name: modalName,
          });
          toast.success("Sharable link copied!");
        }}
      >
        <div className="px-4 h-full cursor-pointer flex justify-center items-center">
          <span className="text-xs leading-[18px] font-medium text-[#70C3FF] font-inter hover:opacity-90 dark:hover:text-[#3e94ff]">
            COPY LINK
          </span>
        </div>
      </CopyToClipboard>
    </div>
  );
}

export default CopyLink;
